import $ from "jquery";

const showMore = $(".show-more ");

showMore.on("click", function () {
  $(this).hide();
  $(this).siblings("p").find(".hidden-text").css("visibility", "visible");
});

